import dynamic from 'next/dynamic'
import { ZoningIcon } from 'src/components/insights/icons/zoning'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/zoning-codes.png'

const ZoningCodes = dynamic(() => import('src/components/insights/zoning/codes'), { ssr: false })

export const ZoningCodesWidget: InsightBuilderWidget = {
  id: 'zoning-controls',
  name: 'Zoning Controls',
  type: 'Zoning',
  icon: ZoningIcon,
  component: ZoningCodes,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
